import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Input, Collapse, Alert } from 'reactstrap';
import { db } from '../firebase/firebase';



const style = {
  container: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    zIndex: 10000
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    opacity: '.25',
    zIndex: 9999
  },
  form: {
    width: '85vw',
    maxWidth: 340,
  },
  textarea: {
    height: 100,
    fontSize: '.875rem',
    resize: 'none'
  },
  input: {
    fontSize: '.875rem',
  }
}

class Feedback extends Component {
  constructor(props){
    super(props);
    this.state = {
      showTextarea: false,
      showMSG: false,
      text: '',
      mail: ''
    };
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({[e.target.name]: e.target.value});
  }

  handleSubmit = () => {
    if(this.state.text !== ''){
      const newDate = new Date();
      var newFeedbackRef = db.ref('feedback').push();
      newFeedbackRef.set({
        user: this.state.mail,
        text: this.state.text,
        timestamp: newDate.toISOString(),
        parameter: {
          path: this.props.path,
          query: this.props.query,
          type: 'feedback-button'
        }
      });

      this.setState({
        showTextarea: false,
        text: '',
        showMSG: true
      });

      setTimeout(() => {
        this.setState({ showMSG: false });
      }, 2000);
    }
  }

  render() {
      return (
        <React.Fragment>
          { this.state.showTextarea && <div id="feedback_overlay" className="bg-dark paul-feedback-overlay" style={style.overlay} onClick={ () => this.setState({showTextarea: false}) }></div> }
          <div id="feedback" className="rounded text-right m-3 m-sm-5" style={style.container}>
            <Alert color="secondary" className={ (this.state.showMSG ? 'd-block' : 'd-none') + ' text-center' }>Danke für dein Feedback!</Alert>

              <Collapse isOpen={this.state.showTextarea} style={style.form} className="bg-light shadow-lg rounded mb-3 text-right p-2 triangle-bottom-right-light">
                <Input type="textarea" name="text" className="rounded-0 pt-2 d-block paul-feedback-textarea" style={style.textarea} value={ this.state.text } onChange={ this.handleChange } placeholder="Was können wir besser machen?" />
                <Input type="email" name="mail" className="border-top rounded-0 paul-feedback-email mb-2" value={ this.state.email } style={style.input}  onChange={ this.handleChange } placeholder="Deine E-Mail" bsSize="sm" />
                <Button color="secondary" block onClick={ this.handleSubmit } className="paul-feedback-submit"><i className="fas fa-envelope mr-2"></i>Feedback senden</Button>
              </Collapse>

              <Button color="dark" className="shadow paul-feedback-toggle" onClick={ () => this.setState({showTextarea: !this.state.showTextarea}) }>
                <i className="fas fa-comment-alt"></i>
                <span className="ml-2 d-none d-sm-inline">Gib uns Feedback</span>
              </Button>
          </div>
        </React.Fragment>
      )
  }
}

const mapStateToProps = (state, props) => ({
  path: props.location.pathname,
  query: state.query
});

export default withRouter(connect(mapStateToProps)(Feedback));



// WEBPACK FOOTER //
// ./src/components/Feedback.js